import { render, staticRenderFns } from "./Ordinary.vue?vue&type=template&id=0cad9abc&scoped=true"
import script from "./Ordinary.vue?vue&type=script&lang=js"
export * from "./Ordinary.vue?vue&type=script&lang=js"
import style0 from "./Ordinary.vue?vue&type=style&index=0&id=0cad9abc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cad9abc",
  null
  
)

export default component.exports